module.exports = __webpack_public_path__ + "static/media/recharge-why-resilience-text-it.aa79ffa6.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/playbooks/recharge-why-resilience-text-it.md
// module id = 510
// module chunks = 18